export default "__VITE_ASSET__C65OTDvR__"